import styled from "styled-components";

export const StyledAnchor = styled.a<{ underline?: boolean }>`
  ${({ underline }) => underline && `text-decoration: underline;`}
`;
